<template>
  <div>
    <hr class="a-hr-form">
    <div class="contractor__add-user" v-if="permissions.CAN_INVITE_USER">
      <h2>{{$t('form.contractor.users-list')}}:</h2>
      <button class="gui-btn gui-btn--red gui-btn--w-278" v-t="'buttons.invite-user'" v-if="mode === 'view'" @click.prevent="mode = 'edit'"></button>
    </div>

    <div class="contractor__container-edit" v-if="mode === 'edit'">
      <div class="a-container-form contractor__block">
        <div class="a-input-group a-input-group--contractor">
          <p class="a-label">{{$t('labels.email')}}:</p>
          <div class="a-input-group__prepend ">@</div>
          <input type="email" placeholder="Email" v-model="email">
        </div>
      </div>
      <div class="a-container-form contractor__block" v-if="permissions.CAN_VIEW_ADMIN">
        <p class="a-label">{{$t('form.contractor.role')}}:</p>
        <dropdown-new v-model="role" class="select-w-260">
          <option value="main" label="form.contractor.role-list.main-organizer"></option>
          <option value="commission" label="form.contractor.role-list.member-commission"></option>
        </dropdown-new>
      </div>
      <div class="personal-data__btn-block">
        <button class="gui-btn gui-btn--red gui-btn--w-140" @click.prevent="onInviteClick" v-t="'buttons.invite'"></button>
        <button class="gui-btn gui-btn--white-border gui-btn--w-140" @click.prevent="mode = 'view'" v-t="'buttons.cancel'"></button>
      </div>
    </div>

    <user v-for="user in users" :key="user.id" :user="user"></user>

    <modal v-if="showInviteSent">
      <template v-slot:header>
        <h5 class="modal-title">{{$t('form.contractor.invitation.title')}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="showInviteSent = false">
          <span aria-hidden="true"><img src="@/assets/img/static/b-icon_close_x.svg" alt=""></span>
        </button>
      </template>

      <template v-slot:body>
        <div class="modal-body__registration">
          <p v-if="error">{{$t(error)}}</p>
          <p v-else>{{$t('form.contractor.invitation.body')}}</p>
        </div>
      </template>

      <template v-slot:footer>
        <button class="gui-btn gui-btn--white-border" @click.prevent="showInviteSent = false" v-t="'buttons.next'"></button>
      </template>
    </modal>

    <loading v-if="loading"></loading>
  </div>
</template>

<script>
  import api from '@/api'
  import User from './ContractorUser'
  import Loading from '@/components/Loading'
  import Modal from '@/widgets/modal'

  export default {
    components: {
      User, Loading, Modal
    },

    data: () => ({
      mode: 'view',
      email: undefined,
      role: 'main',
      showInviteSent: false,
      error: undefined
    }),

    computed: {
      permissions() {
        return this.$store.getters.currentUser.permissions
      },

      organization() {
        return this.$store.getters.currentOrganization;
      },

      users() {
        return this.$store.getters.organizationUsers(this.organization.id);
      }
    },

    async created() {
      this.runAction(async () => {
        try {
          await this.$store.dispatch('fetchOrganizationUsers', {organizationId: this.organization.id})
        }
        catch(e) {
          console.error('unable to fetch organization users', e);
          this.globalErrorHandler(e);
        }
      });
    },

    methods: {
      async onInviteClick() {
        this.error = undefined;

        this.runAction(async () => {
          try {
            await this.$store.dispatch('sendInvite', {
              email: this.email,
              role: this.permissions.CAN_VIEW_ADMIN ? this.role : undefined
            });
          }
          catch(e) {
            console.error('Unable to send invite due to unexpected error', e);

            this.error = 'errors.unknown';

            if (e == api.Errors.EMAIL_BUSY) {
              this.error = 'errors.email-busy';
            }
          }

          this.showInviteSent = true;
          this.email = undefined;
          this.mode = 'view';
        });
      }
    }
  }
</script>

<style scoped>

</style>
